import Select from "./select";

function SexSelect(props) {
  return (
    <Select
      options={[
        { key: 0, label: "Unknown" },
        { key: 1, label: "Male" },
        { key: 2, label: "Female" },
      ]}
      label="Sex"
      {...props}
    />
  );
}
export default SexSelect;
